import ReactPaginate from "react-paginate";
import Icon from "../Icon/Icon";

const PaginationComponent = ({ pageCount = 1, setPageNumber }) => {
  if (pageCount === 1) return null;

  return (
    <ReactPaginate
      previousLabel={<Icon name="chevron-left" />}
      nextLabel={<Icon name="chevron-right" />}
      pageClassName="page-item"
      pageLinkClassName="btn"
      previousClassName="page-item"
      previousLinkClassName="btn"
      nextClassName="page-item"
      nextLinkClassName="btn"
      breakLabel="..."
      breakClassName="page-item"
      breakLinkClassName="btn"
      pageCount={pageCount}
      marginPagesDisplayed={1}
      pageRangeDisplayed={2}
      onPageChange={(e) => setPageNumber(e.selected + 1)}
      containerClassName="pagination"
      activeClassName="btn-primary rounded"
    />
  );
};
export default PaginationComponent;
